import { combineReducers } from 'redux'
import common from './common.reducer'
import user from './user.reducer'
import purchaseOrder from './purchase-order.reducer'
import navbarNotification from './notification.reducer'
import project from './project.reducer'
import globalSetting from './global-setting.reducer'
import { reducer as notificationsReducer } from 'reapop'
import taskReducer from '../slice/add-task';
import resourcesReducer from '../slice/resources';
import projectDetailReducer from '../slice/project-detail';
import projectSummaryReducer from '../slice/project-summary';
import customerReducer from '../slice/customer'
import dashboardReducer from '../slice/dashboard';
import subscriptionSlice from '../slice/subscription.slice';
import catalogSlice from '../slice/catalog.slice';
import templateCategorySlice from '../slice/template-category.slice';
import templateSlice from '../slice/template.slice';

const rootReducer = combineReducers({
  common,
  user,
  notifications: notificationsReducer(),
  navbarNotification,
  purchaseOrder,
  project,
  globalSetting,
  task: taskReducer,
  resources: resourcesReducer,
  projectDetail: projectDetailReducer,
  projectSummary: projectSummaryReducer,
  customerData: customerReducer,
  dashboard: dashboardReducer,
  subscription: subscriptionSlice,
  catalog: catalogSlice,
  category: templateCategorySlice,
  template: templateSlice
})

export default rootReducer
